
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import IconCircle from './IconCircle.vue'

@Component({
  components: { IconCircle },
})
  export default class CircularImage extends Vue {
  @Prop({ default: '' }) readonly imageUrl!: string
  @Prop({ default: false }) readonly isMobile!: boolean
  @Prop({ default: () => [] })
  readonly items!: Array<{
    icon: string
    link: string
    tooltip: string
  }>

  // Tamaño total del contenedor (ej: 400px)
  @Prop({ default: 400 }) readonly size!: number

  // Radio para ubicar íconos alrededor
  get radius () {
    // Ajusta según tu diseño (por ejemplo, mitad del tamaño menos 70)
    return this.size / 2 - 70
  }

  // Factor de escala para la imagen; 0.5 => 50%, 0.66 => 66%, etc.
  // Puedes exponerlo como prop también si lo deseas (para personalizar).
  get imageScale () {
    return 0.66
  }
  }
